<template>
  <div class="input-model-box">
    <el-input
      placeholder="请输入名称或编码"
      v-model="storeName"
      @blur="storeNameChange"
      :disabled="column.disabled"
    >
      <template slot="append">
        <div class="el-icon-more more-btn" @click="showStoreList"></div>
      </template>
    </el-input>
    <el-dialog
      :title="column.label"
      :visible.sync="dialogVisible"
      @close="beforeClose"
      center
      :modal-append-to-body="false"
    >
      <purchase-list-template
        ref="listTable"
        @rowClick="storeCheck"
        :tableOptions="tableOptions"
      ></purchase-list-template>
    </el-dialog>
  </div>
</template>
<script>
  import api from "@/config/api";
  import purchaseListTemplate from "@/components/template/purchaseListTemplate.vue";

  export default {
    components: {purchaseListTemplate},
    props: ["column", "defaultValue"],
    data() {
      return {
        storeName: "",
        checkList: [],
        dialogVisible: false,
        storeList: null,
        tableOptions: {
          url: api.store.store + "/query/page",
          height: "100%",
          isRowClick: true,
          params: this.column.params,
          columns: [
            {label: "编码", prop: "code", align: "center"},
            {label: "名称", prop: "name", align: "center"}
          ]
        },
        btnClick: false
      };
    },
    watch: {
      defaultValue() {
        if (this.defaultValue > 0) {
          this.$axios
            .fetchGet(api.store.getStoreDetail + "?id=" + this.defaultValue)
            .then(res => {
              console.log(res);
              this.storeName = res.data.name;
            });
        } else {
          this.storeName = "总部";
        }
      }
    },
    mounted() {
      if (this.defaultValue == -1) {
        this.storeName = "总部";
        this.checkList.name = "总部";
      }else {
        if (this.defaultValue) {
          this.$axios
            .fetchGet(api.store.getStoreDetail + "?id=" + this.defaultValue)
            .then(res => {
              this.storeName = res.data.name;
            });
        }
      }
    },
    methods: {
      showStoreList() {
        if (this.column.disabled) return;
        this.btnClick = true;
        this.dialogVisible = true;
        this.getStoreList();
      },
      storeNameChange() {
        if (this.btnClick) return;
        if (this.storeName === "" || this.storeName === null) return;
        this.dialogVisible = true;
        this.getStoreList();
      },
      getStoreList() {
        if (this.btnClick) this.storeName = "";
        this.storeList = [];
        let user = this.$utils.getSysUser();
        this.$nextTick(() => {
          this.$refs["listTable"].initData({
            otherName: this.storeName,
            userStoreId: user.storeId
          });
          this.setStoreName();
        });
      },
      setStoreName() {
        if (this.storeList.length === 1) {
          this.checkList = this.storeList[0];
          this.storeName = this.storeList[0].name;
          this.$emit("valueChange", this.checkList, this.column);
        } else {
          this.dialogVisible = true;
        }
      },
      storeCheck(row) {
        this.checkList = row;
        this.storeName = row.name;
        this.dialogVisible = false;
        this.$emit("valueChange", row, this.column);
      },
      beforeClose() {
        this.storeName = this.checkList.name;
        this.btnClick = false;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/business/storeIdInputDialog.vue